// 订单管理
export default [
  {
    path: "/order",
    meta: { title: "订单管理" },
    component: () => import("../views/order/index"),
    children: [
      {
        path: "/order/orderList",
        name: "orderList",
        meta: { title: "课程订单", isMenu: true },
        component: () => import("../views/order/orderList"),
      },
      {
        path: "/order/LiveStreamingOrder",
        name: "LiveStreamingOrder",
        meta: { title: "直播订单", isMenu: true },
        component: () => import("../views/order/LiveStreamingOrder"),
      },
      {
        path: "/order/studyTour",
        meta: { title: "游学订单", isMenu: true },
      },
      {
        path: "/order/studyTour/studyTourOrder",
        name: "studyTourOrder",
        meta: { title: "订单列表", isMenu: true },
        component: () => import("../views/order/studyTourOrder.vue"),
      },
      {
        path: "/order/studyTour/afterSalesOrder",
        name: "afterSalesOrder",
        meta: { title: "售后订单", isMenu: true },
        component: () => import("../views/order/afterSalesOrder.vue"),
      },
      {
        path: "/order/detail/studyTourOrderDet",
        name: "studyTourOrderDet",
        meta: { title: "订单详情", isMenu: true },
        component: () => import("../views/order/detail/studyTourOrderDet.vue"),
      },
      {
        path: "/order/detail/afterSalesOrderDet",
        name: "afterSalesOrderDet",
        meta: { title: "售后订单详情", isMenu: true },
        component: () => import("../views/order/detail/afterSalesOrderDet.vue"),
      },
    ],
  },
]
